import React from "react";
import {
	TouchableOpacity,
	StyleSheet,
	View,
} from "react-native";
import noop from "noop3";

import Style from "@aetonix/styles";

import StyledText from "ae-base/Base/StyledText";
import StyledIcon from "ae-base/Base/StyledIcon";

var styles = StyleSheet.create({
	button: {
		paddingVertical: Style.layout.marginSmall,
		paddingHorizontal: Style.layout.marginContentSmall,
		alignSelf: "center",
		borderRadius: 24,
		marginHorizontal: Style.layout.marginSmall * 2
	},
	content: {
		flex: 1,
		justifyContent: "center",
		alignItems: "center"
	},
	icon: {
		flex: 35,
		justifyContent: "flex-end",
		paddingBottom: Style.layout.marginSmall,
		alignItems: "center",
	},
	text: {
		textAlign: "center",
		flex: 26,
	},
	disabled: {
		opacity: Style.look.disabled,
	},

	containerWhite: {
		backgroundColor: Style.look.background,
	},
	containerHighlight: {
		backgroundColor: Style.colors.highlight,
	},
	containerSecondary: {
		backgroundColor: Style.colors.secondary,
	},
	small: {
		borderRadius: 16,
		width: 128,
		height: 128
	}
});

export default function SquareButton(props){
	var onPress = props.onPress;
	var title = props.title || "";

	var disabled = props.disabled;
	var contrast = props.contrast;
	var clear = props.clear;
	var highlight = props.highlight;
	var secondary = props.secondary;
	var small = props.small;

	var iconName = props.icon || "dot-circle-o";

	var styleList = [styles.button];

	if(disabled){
		onPress = noop;
		styleList.push(styles.disabled);
	}

	if(small){
		styleList.push(styles.small);
	}

	var textColor = {
		black: true
	};
	var iconColor = {};
	var containerColor = null;

	styleList.push(containerColor);

	if(contrast){
		textColor = {
			contrast: true
		};
		iconColor = {
			contrast: true
		};
	}

	if(!clear){
		containerColor = styles.containerWhite;
	}

	if(highlight){
		containerColor = styles.containerHighlight;
	}

	if(secondary){
		containerColor = styles.containerSecondary;
	}

	styleList.push(containerColor);

	return (
		<View>
			<TouchableOpacity accessibilityComponentType="button" style={styleList} onPress={onPress}>
				<View style={styles.content}>
					<View style={styles.icon}>
						<StyledIcon name={iconName} hugeHeading {...iconColor} />
					</View>
					<StyledText style={styles.text} compact bold {...textColor}>
						{title}
					</StyledText>
				</View>
			</TouchableOpacity>
		</View>
	);
}
